import { PlatformSettingsSection } from "@/components/platform-settings/PlatformSettingsSection";

// #235 UC-3: Plattform-Settings-Seite (admin-only). Plattform-weite Defaults + Policy-Schalter.
export function PlatformSettingsPage() {
  return (
    <div className="max-w-3xl space-y-5">
      <PlatformSettingsSection />
    </div>
  );
}
